export default "__VITE_ASSET__L$3Zn4sP__"